/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import useT, {
    UseTranslationOptions,
} from "../../../Basis/Internationalisierung/Hooks/useTranslation";
import ExportvorlageFuer from "../Commands/ExportvorlageFuer";

export const useTranslation = (options?: UseTranslationOptions) => useT("i18nExporte", options);

type ExportvorlageFuerKeys = { [K in ExportvorlageFuer]: `exportvorlageFuer.${Lowercase<K>}` };
const exportvorlageFuerKeys: ExportvorlageFuerKeys = {
    "ADRESSEN": "exportvorlageFuer.adressen",
    "BELEGE": "exportvorlageFuer.belege",
    "TEILNAHMEN": "exportvorlageFuer.teilnahmen",
    "SEMINARE": "exportvorlageFuer.seminare",
    "BELEGPOSITIONEN": "exportvorlageFuer.belegpositionen",
    "WEBINARTEILNAHMEN": "exportvorlageFuer.webinarteilnahmen",
    "BESTELLTEARTIKEL": "exportvorlageFuer.bestellteartikel",
    "WARTELISTE": "exportvorlageFuer.warteliste",
    "ARTIKEL": "exportvorlageFuer.artikel",
    "DOZIERENDE": "exportvorlageFuer.dozierende",
    "PROVISIONEN": "exportvorlageFuer.provisionen",
    "ZAHLUNGEN": "exportvorlageFuer.zahlungen"
};

export const translationKeys = {
    spaltenTable: {
        spalte: "spaltenTable.spalte",
    },
    erstelleCsvExportDialog: {
        exportvorlage: "erstelleCsvExportDialog.exportvorlage",
        weiter: "erstelleCsvExportDialog.weiter",
        ohneVorlageWeiter: "erstelleCsvExportDialog.ohneVorlageWeiter",
        zurueck: "erstelleCsvExportDialog.zurueck",
        keineVorlage: "erstelleCsvExportDialog.keineVorlage",
        dialogText: "erstelleCsvExportDialog.dialogText",
        spalten: "erstelleCsvExportDialog.spalten",
        filter: "erstelleCsvExportDialog.filter",
        exportieren: "erstelleCsvExportDialog.exportieren",
        abbrechen: "erstelleCsvExportDialog.abbrechen",
    },
    exportvorlagenBreadcrumb: {
        exportvorlagen: "exportvorlagenBreadcrumb.exportvorlagen",
    },
    exportvorlagenView: {
        exportvorlagen: "exportvorlagenView.exportvorlagen",
        anlegenCaption: "exportvorlagenView.anlegenCaption",
        loeschenCaption: "exportvorlagenView.loeschenCaption",
        name: "exportvorlagenView.name",
        fuer: "exportvorlagenView.fuer",
        spalten: "exportvorlagenView.spalten",
        filter: "exportvorlagenView.filter",
    },
    legeExportvorlageAnDialog: {
        nameCaption: "legeExportvorlageAnDialog.nameCaption",
        fuerCaption: "legeExportvorlageAnDialog.fuerCaption",
        dialogCaption: "legeExportvorlageAnDialog.dialogCaption",
        dialogText: "legeExportvorlageAnDialog.dialogText",
        anlegenCaption: "legeExportvorlageAnDialog.anlegenCaption",
        abbrechenCaption: "legeExportvorlageAnDialog.abbrechenCaption",
    },
    exportvorlageFuer: exportvorlageFuerKeys,
    loescheExportvorlagenDialog: {
        dialogCaption: "loescheExportvorlagenDialog.dialogCaption",
        dialogText: "loescheExportvorlagenDialog.dialogText",
    },
    exportvorlagenNavigationView: {
        exportvorlagen: "exportvorlagenNavigationView.exportvorlagen",
    },
    exportvorlageView: {
        exportvorlage: "exportvorlageView.exportvorlage",
        details: "exportvorlageView.details",
        spaltenUndFilter: "exportvorlageView.spaltenUndFilter",
    },
    exportvorlageDetailsView: {
        speichern: "exportvorlageDetailsView.speichern",
        loeschen: "exportvorlageDetailsView.loeschen",
        name: "exportvorlageDetailsView.name",
        sortieren: "exportvorlageDetailsView.sortieren",
        dialogCaption: "exportvorlageDetailsView.dialogCaption",
        dialogText: "exportvorlageDetailsView.dialogText",
        jaCaption: "exportvorlageDetailsView.jaCaption",
        neinCaption: "exportvorlageDetailsView.neinCaption",
    },
    exportvorlageSpaltenUndFilterBreadcrumb: {
        caption: "exportvorlageSpaltenUndFilterBreadcrumb.caption",
    },
};
